export default __webpack_public_path__ + "static/media/nigeria-losing-200,000.9469bea7.jpeg";